import { Button, ButtonProps } from '@shared/components';
import { forwardRef } from 'react';
import { MdClear } from 'react-icons/md';

export const CloseButton = forwardRef<HTMLButtonElement, ButtonProps>(
  function CloseButton(props, ref) {
    return (
      <Button
        ref={ref}
        aria-label="Close Button"
        size="small"
        isGhost
        icon={<MdClear size={24} />}
        {...props}
      />
    );
  }
);
